// extracted by mini-css-extract-plugin
export default {"blurb":"FeatureLiving_blurb__1jgWC","images":"FeatureLiving_images__vRsp+"};